export const chartColorScheme: string[] = [
  "#36c3ed", // Light blue
  "#4a90e2", // Medium blue
  "#50e3c2", // Teal
  "#f5a623", // Orange
  "#b8e986", // Light green
  "#bd10e0", // Purple
  "#9013fe", // Violet
  "#417505", // Dark green
  "#7ed321", // Lime green
  "#8b572a", // Brown
  "#d0021b", // Red
  "#9b9b9b", // Gray
  "#4a4a4a", // Dark gray
  "#ff9900", // Amber
  "#03a9f4", // Sky blue
  "#009688", // Green-blue
  "#cddc39", // Lime
  "#ff5722", // Deep orange
  "#673ab7", // Deep purple
  "#3f51b5", // Indigo
  "#795548", // Brown-grey
  "#607d8b", // Blue-grey
  "#f44336", // Bright red
  "#e91e63", // Pink
]
